import { render, staticRenderFns } from "./financialInsuranceApplyForRules.vue?vue&type=template&id=ab72e098&scoped=true"
import script from "./financialInsuranceApplyForRules.vue?vue&type=script&lang=js"
export * from "./financialInsuranceApplyForRules.vue?vue&type=script&lang=js"
import style0 from "./financialInsuranceApplyForRules.vue?vue&type=style&index=0&id=ab72e098&prod&lang=scss"
import style1 from "./financialInsuranceApplyForRules.vue?vue&type=style&index=1&id=ab72e098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab72e098",
  null
  
)

export default component.exports